module.exports = __webpack_public_path__ + "static/media/eb9405ff-cf74-46af-b18e-05b911d2aacf.0cc7502a.JPG";